export default __webpack_public_path__ + "static/media/google-login-icon-png.0a86193b.png";